import { Checkbox, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { registerUser } from "../functions/api/register";
import { exportUpdateUser } from "../layout/Navbar";
import { userLogin } from "../functions/api/login";

export default function Signup() {
  const navigator = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const [termsChecked, setTermsChecked] = useState(false);
  const [smsChecked, setSmsChecked] = useState(false);

  useEffect(() => {
    const submitBtn = document.getElementById("signup-submit-btn");
    if (submitBtn) {
      if (termsChecked && smsChecked) {
        submitBtn.setAttribute("data-active", "true");
      } else {
        submitBtn.setAttribute("data-active", "false");
      }
    }
  }, [termsChecked, smsChecked]);

  function handleOnSignUp() {
    let btn = document.getElementById("signup-submit-btn");
    let name = document.getElementById("signup-input-fullname");
    let email = document.getElementById("signup-input-email");
    let pwd = document.getElementById("signup-input-password");
    let cpwd = document.getElementById("signup-input-confirm-password");

    if (btn) btn.dataset.active = "false";

    registerUser(
      {
        email: email.value,
        name: name.value,
        password: pwd.value,
        cpassword: cpwd.value,
      },
      (status) => {
        if (status === "success") {
          if (btn) btn.dataset.active = "true";

          if (status === "success") {
            userLogin(email.value, pwd.value, false, (status) => {
              if (btn) btn.dataset.active = "true";

              if (status === "success") {
                exportUpdateUser();

                if (state.redirectTo) {
                  navigator(state.redirectTo, {
                    state: {
                      redirectTo: null,
                      ...state,
                    },
                  });
                } else {
                  navigator("/");
                }
              } else {
                if (btn) btn.dataset.active = "true";
              }
            });
          } else {
            if (btn) btn.dataset.active = "true";
          }
        } else {
          if (btn) btn.dataset.active = "true";
        }
      }
    );
  }

  return (
    <div className="grid-container" id="signup-page">
      <main className="signup-main-container">
        <div className="signup-card">
          <div className="signup-card-top">
            <h1 className="signup-title">Sign Up</h1>
            <p className="signup-title-desc">
              You'll be up & running in 2 minutes
            </p>
          </div>

          <div className="signup-input-wrap">
            <TextField
              size="small"
              label="Full name"
              placeholder="Full name"
              type="text"
              className="signup-input"
              id="signup-input-fullname"
              fullWidth
            />
          </div>
          <div className="signup-input-wrap">
            <TextField
              size="small"
              label="Email"
              placeholder="Email"
              type="email"
              className="signup-input"
              id="signup-input-email"
              fullWidth
            />
          </div>
          <div className="signup-input-wrap">
            <TextField
              size="small"
              label="Phone Number"
              placeholder="Phone Number"
              type="tel"
              className="signup-input"
              id="signup-input-phone"
              fullWidth
            />
          </div>
          <div className="signup-input-wrap">
            <TextField
              size="small"
              label="Password"
              placeholder="Password"
              type="password"
              className="signup-input"
              id="signup-input-password"
              fullWidth
            />
          </div>
          <div className="signup-input-wrap">
            <TextField
              size="small"
              label="Confirm Password"
              placeholder="Confirm Password"
              type="password"
              className="signup-input"
              id="signup-input-confirm-password"
              fullWidth
            />
          </div>

          <div className="signup-input-wrap" style={{ flexDirection: 'row'}}>
            <Checkbox
              id="signup-terms-agreement-checkbox"
              name="signup-terms-agreement"
              color="primary"
              onChange={(e) => setTermsChecked(e.target.checked)}
            />
            <p className="text-justify" style={{ fontSize: '12px', color: '#555' }}>
              By signing up, you agree to our{" "}
              <a
                href="/TermsandConditions.pdf"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="/PrivacyPolicy.pdf">Privacy Policy</a>.
            </p>
          </div>

          <div className="signup-input-wrap" style={{flexDirection: 'row'}}>
            <Checkbox
              id="signup-sms-consent-checkbox"
              name="signup-sms-consent"
              color="primary"
              onChange={(e) => setSmsChecked(e.target.checked)}
            />
            <p className="text-justify" style={{ fontSize: '12px', color: '#555' }}>
              By signing up, you agree to receive automated SMS alert messages from casi.io at the number provided.
              Message and data rates may apply.
            </p>
          </div>

          <button
            style={{marginTop: 0}}
            data-active="false"
            id="signup-submit-btn"
            onClick={handleOnSignUp}
            className="button"
          >
            Sign Up
          </button>

          <div className="signup-link-wrap">
            <p className="signup-link-text">Already have an account ?</p>
            <Link className="signup-link" to="/login">
              Login
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
